import { createProjectSuccessAction, fetchProjectSuccessAction, deleteProjectSuccessAction, cloneProjectSuccessAction, updateProjectErrorAction } from '.'
import { toggleImageAction, toggleVideoAction } from '../toggleMedia'
import { clearErrorsAction } from '../errors'
import { getCsrfToken } from '../utils/csrfUtils'
import { Config } from '../utils/config'
import { fieldUpdateSuccessAction } from '../fieldUpdateIndicator'
import { fetchVoicesSuccessAction } from '../textEditor'

const createNewProject = async (dispatch, throwAsyncError) => {
  try {
    const csrfToken = await getCsrfToken()

    const response = await fetch(`${Config.BASE_URL}/project`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': csrfToken
      },
      credentials: 'include'
    })

    const requestId = response.headers.get('X-Request-ID')

    if (!response.ok) {
      const error = new Error(`HTTP error! Status: ${response.status}`)
      error.status = response.status
      error.requestId = requestId
      throw error
    }

    const result = await response.json()

    dispatch(createProjectSuccessAction(result))
  } catch (error) {
    throwAsyncError(error)
  }
}

const fetchProject = async (dispatch, payload, throwAsyncError) => {
  try {
    const response = await fetch(
      `${Config.BASE_URL}/project/${payload.projectId}`,
      {
        method: 'GET',
        credentials: 'include'
      }
    )

    const requestId = response.headers.get('X-Request-ID')

    if (!response.ok) {
      const error = new Error(`HTTP error! Status: ${response.status}`)
      error.status = response.status
      error.requestId = requestId
      throw error
    }

    const result = await response.json()

    result.project.project_data_hash
      ? dispatch(toggleVideoAction())
      : dispatch(toggleImageAction())

    dispatch(fetchProjectSuccessAction(result))
  } catch (error) {
    throwAsyncError(error)
  }
}

const deleteProject = async (dispatch, payload, throwAsyncError) => {
  try {
    const csrfToken = await getCsrfToken()

    const response = await fetch(
      `${Config.BASE_URL}/project/${payload.projectId}`,
      {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'x-csrf-token': csrfToken
        }
      }
    )

    const requestId = response.headers.get('X-Request-ID')

    if (!response.ok) {
      const error = new Error(`HTTP error! Status: ${response.status}`)
      error.status = response.status
      error.requestId = requestId
      throw error
    }

    const result = await response.json()
    dispatch(deleteProjectSuccessAction(result))
  } catch (error) {
    throwAsyncError(error)
  }
}

const cloneProject = async (dispatch, payload, throwAsyncError) => {
  try {
    const csrfToken = await getCsrfToken()

    const response = await fetch(`${Config.BASE_URL}/project/clone`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': csrfToken
      },
      credentials: 'include',
      body: JSON.stringify({ projectId: payload.projectId })
    })
    const requestId = response.headers.get('X-Request-ID')

    if (!response.ok) {
      const error = new Error(`HTTP error! Status: ${response.status}`)
      error.status = response.status
      error.requestId = requestId
      throw error
    }

    const result = await response.json()
    dispatch(cloneProjectSuccessAction(result))
  } catch (error) {
    throwAsyncError(error)
  }
}

const updateProject = async (dispatch, projectId, updatedData, throwAsyncError) => {
  try {
    const csrfToken = await getCsrfToken()

    const response = await fetch(`${Config.BASE_URL}/project/${projectId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'x-csrf-token': csrfToken
      },
      credentials: 'include',
      body: JSON.stringify(updatedData)
    })

    const requestId = response.headers.get('X-Request-ID')
    const result = await response.json()

    dispatch(clearErrorsAction())

    if (response.status === 400) {
      dispatch(updateProjectErrorAction(result))
    } else if (!response.ok) {
      const error = new Error(`HTTP error! Status: ${response.status}`)
      error.status = response.status
      error.requestId = requestId
      throw error
    } else {
      dispatch(fetchVoicesSuccessAction(result))
      dispatch(fieldUpdateSuccessAction(updatedData))
    }
  } catch (error) {
    error.status ? throwAsyncError(error) : console.error(error)
  }
}

export { createNewProject, fetchProject, deleteProject, cloneProject, updateProject }
